import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { useEphemeralStore } from '@/lib/app-store';
import { PortalAnimateNumber } from '../../$portalId/-components/portal-animate-number';

export const Route = createFileRoute('/www/.internal/bump')({
	component: Component,
});

function Component() {
	const [collected, setCollected] = useState(140);
	const [donations, setDonations] = useState(12);
	const donationConfirmed = useEphemeralStore((s) => s.donationConfirmed);
	const setDonationConfirmed = useEphemeralStore((s) => s.setDonationConfirmed);

	const simulateDonation = () => {
		setCollected((v) => v + Math.round(Math.random() * 5000) / 100 + 1);
		setDonations((v) => v + 1);
		setDonationConfirmed(true);
	};

	return (
		<div className="relative flex flex-col gap-8 overflow-y-auto p-8">
			<div className="mx-auto w-full max-w-3xl space-y-8">
				<div>
					<h1 className="text-2xl font-bold">Bump Animation Demo</h1>
					<p className="text-muted-foreground mt-1 text-sm">
						Uses the real PortalAnimateNumber. Click "Donate" to trigger.
					</p>
				</div>

				<div className="flex justify-center gap-16 rounded-lg border p-8 text-3xl font-bold">
					<div className="flex flex-col items-center gap-1">
						<span className="text-xs font-normal text-gray-400">Donations</span>
						<PortalAnimateNumber locale="es" value={donations} />
					</div>
					<div className="flex flex-col items-center gap-1">
						<span className="text-xs font-normal text-gray-400">Collected</span>
						<PortalAnimateNumber locale="es" value={collected} suffix="€" decimalDigits={2} />
					</div>
				</div>

				<div className="flex items-center gap-4">
					<button
						type="button"
						className="rounded bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50"
						onClick={simulateDonation}
						disabled={donationConfirmed}
					>
						Donate
					</button>
					<span className="font-mono text-sm">
						donationConfirmed: <strong>{String(donationConfirmed)}</strong>
					</span>
				</div>
			</div>
		</div>
	);
}
